import { TaskType } from "src/types";

export interface AISuggest {
  title: string;
  predefinedPrompt: string;
  id: string;
}

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.length > 0;

const isAISuggest = (value: unknown): value is AISuggest =>
  typeof value === "object" &&
  value !== null &&
  isNonEmptyString((value as AISuggest).title) &&
  isNonEmptyString((value as AISuggest).predefinedPrompt);

export const isAISuggestArray = (value: unknown): value is AISuggest[] =>
  Array.isArray(value) && value.every(isAISuggest);

export type SuggestionContext =
  | "get-started"
  | "activity"
  | "projects"
  | "creator-search"
  | "creator-database"
  | "dictionary"
  | "data-hub"
  | "coupon-groups"
  | "my-tasks"
  | `project-${TaskType}s`;
